export const eggplant = "#3C285A";

export const buttonMedBlue = "#1865F2";

export const white = "#FFFFFF";

export const green = "#14BF96";

export const red = "#D92916";

export const gold = "#FFB100";

export const black = "#000000";

export const darkGrey = "#21242C";

export const lilac = "#E0D6F4";

export const darkGreen = "#156350";

export const darkRed = "#5F1A12";

export const darkGold = "#7D5B0E";

export const errorRed = "#A81708";
